import api from '@/api';
import { API_BASE_URL } from '..';
import { MarketingPublicationResponse } from './marketingPublication.types';

const CONTROLLER_URL = `${API_BASE_URL}/marketingPublication`;

const marketingPublicationService = {
  async getMarketingPublicationActive() {
    const result = (await api.get(`${CONTROLLER_URL}/active`, null)) as unknown;

    return result as MarketingPublicationResponse;
  },
};

export default marketingPublicationService;
